
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminPanel from './pages/AdminPanel';
import Trackgrowth from './pages/Trackgrowth';
import OngoingOrders from './pages/OngoingOrders';
import SalesInvoice from './pages/SalesInvoice';
import Transaction from './pages/Transaction';
import CustomerSupport from './pages/CustomerSupport';
import Aov from './pages/Aov';
import Bestsellers from './pages/Bestsellers';
import BrandActivity from './pages/BrandActivity';
import UnresolvedProbelem from './pages/UnresolvedProbelem';
import BrandSplit from './pages/BrandSplit'
import RevenueGrowth from './pages/RevenueGrowth'
import Designs from './pages/Designs';
import CodRemittance from './pages/CodRemittance';
import TotalDeposits from  './pages/CodRemittance';
import BrandWiseSellingPrice from './pages/BWsellingPrice';
import VendorPayments from './pages/VendorPayments';
import LoginPage from './pages/Login';
import AuthRoute from './components/AuthRoute';
import CodSummary from './pages/CodSummary';
import GSTcreditNotes from './pages/GSTcreditNotes';
import BrandMonthlyInvoice from './pages/Invoices';
import AdminRTOInventoryPanel from './pages/RTOinventory';
import InventoryPage from './pages/InventoryPage.jsx'
import CODRemittanceTable from './pages/CodSummarySM.jsx';
import InventoryMigration from './pages/MigrationScript.jsx';
import AccountDetails from './pages/AccountDetails.jsx';
import AdminNeckLabels from './pages/Necklabels.jsx';
import B2BOrdersPage from './pages/b2borders.jsx';

function App() {
  return (
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<LoginPage/>} />
          <Route path="/Dashboard" element={<AuthRoute element={AdminPanel} />} />
          <Route path="/trackgrowth" element={<AuthRoute element={Trackgrowth} />} />
<Route path="/trackgrowth/average-order-value" element={<AuthRoute element={Aov} />} />
<Route path="/trackgrowth/best-sellers" element={<AuthRoute element={Bestsellers} />} />
<Route path="/trackgrowth/brand-activity" element={<AuthRoute element={BrandActivity} />} />
<Route path="/trackgrowth/revenue-growth" element={<AuthRoute element={RevenueGrowth} />} />
<Route path="/trackgrowth/brand-split" element={<AuthRoute element={BrandSplit} />} />
<Route path="/trackgrowth/unresolved-problem" element={<AuthRoute element={UnresolvedProbelem} />} />
<Route path="/ongoing-orders" element={<AuthRoute element={OngoingOrders} />} />
<Route path="/Sales-invoices" element={<AuthRoute element={SalesInvoice} />} />
<Route path="/Transaction" element={<AuthRoute element={Transaction} />} />
<Route path="/gstCreditnotes" element={<AuthRoute element={GSTcreditNotes} />} />
<Route path="/Customer-support" element={<AuthRoute element={CustomerSupport} />} />
  <Route path="/inventory/*" element={<AuthRoute element={InventoryPage} />} />
<Route path="/deposits" element={<AuthRoute element={TotalDeposits} />} />
<Route path="/designs" element={<AuthRoute element={Designs} />} />
<Route path="/brand-wise-sellingPrice" element={<AuthRoute element={BrandWiseSellingPrice} />} />
<Route path="/vendor-payments" element={<AuthRoute element={VendorPayments} />} />
<Route path="/brandInvoices" element={<AuthRoute element={BrandMonthlyInvoice} />} />
<Route path="/CodSummary" element={<AuthRoute element={CodSummary} />} />
<Route path="/CodSummary-shipmozo" element={<AuthRoute element={CODRemittanceTable} />} />
<Route path="/RTOinventory" element={<AuthRoute element={AdminRTOInventoryPanel} />} />
<Route path="/inventory-migration" element={<AuthRoute element={InventoryMigration} />} />
<Route path="/accountdetails" element={<AuthRoute element={AccountDetails} />} />
<Route path="/necklabels" element={<AuthRoute element={AdminNeckLabels} />} />
<Route path="/b2bOrders" element={<AuthRoute element={B2BOrdersPage} />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
